import { Button, Col, Modal } from "antd";
import { arrayOf, bool, func, string } from "prop-types";
import { useIntl } from "react-intl";
import { DupeListCol, DupeListRow, DupeListRowHeader } from "./styled";

export const ConfirmDuplicateFormPropertyValuesModal = ({
  isOpen,
  dupeMessages,
  confirmSave,
  cancelSave,
}) => {
  const intl = useIntl();

  const confirm = () => {
    confirmSave();
  };

  const cancel = () => {
    cancelSave();
  };

  return (
    <Modal
      maskClosable={false}
      title={intl.formatMessage({
        id: "confirmDuplicateFormPropertyValuesModal.modalTitle",
      })}
      closable={false}
      open={isOpen}
      destroyOnHidden
      onCancel={cancel}
      footer={[
        <Button
          data-test-id="confirm-duplicate-form-property-values-modal-cancel"
          onClick={cancel}
          key={"cancel"}
        >
          {intl.formatMessage({
            id: "confirmDuplicateFormPropertyValuesModal.cancel",
          })}
        </Button>,
        <Button
          data-test-id="confirm-duplicate-form-property-values-modal-save"
          type="primary"
          key={"save"}
          onClick={confirm}
        >
          {intl.formatMessage({
            id: "confirmDuplicateFormPropertyValuesModal.saveAnyway",
          })}
        </Button>,
      ]}
    >
      <div>
        <Col>
          {dupeMessages &&
            Object.keys(dupeMessages).map((dupeMsgKey) => (
              <DupeListRow key={dupeMsgKey}>
                <DupeListCol>
                  <DupeListRowHeader>
                    {intl.formatMessage({
                      id: `confirmDuplicateFormPropertyValuesModal.${
                        dupeMsgKey.charAt(0).toLowerCase() + dupeMsgKey.slice(1)
                      }`,
                    })}
                    :
                  </DupeListRowHeader>
                </DupeListCol>
                <DupeListCol>
                  {dupeMessages[dupeMsgKey].map((message) => {
                    const separator =
                      dupeMessages[dupeMsgKey].indexOf(message) > 0 ? ", " : "";
                    return (
                      <span key={message}>
                        {`${separator}'${message}`}&apos;
                      </span>
                    );
                  })}
                </DupeListCol>
              </DupeListRow>
            ))}
        </Col>
      </div>
    </Modal>
  );
};

ConfirmDuplicateFormPropertyValuesModal.propTypes = {
  isOpen: bool,
  dupeMessages: arrayOf(string),
  confirmSave: func.isRequired,
  cancelSave: func.isRequired,
};
